import { useNavigate } from "react-router-dom"
import styles from "./styles.module.scss"
import { ReactComponent as BackIcon } from "assets/icons/back.svg"
import CircleButton from "@atoms/icon-button"

export interface IPageHeader {
  title?: React.ReactNode
  subTitle?: React.ReactNode
  hasBackButton?: boolean
  onButtonClick?: () => void
  rightContent?: React.ReactNode
}

const PageHeader: React.FC<IPageHeader> = ({
  title,
  subTitle,
  hasBackButton = true,
  onButtonClick,
  rightContent,
}) => {
  const navigate = useNavigate()
  return (
    <div className={styles.head}>
      <div className={styles.leftContent}>
        {hasBackButton && (
          <CircleButton
            className={styles.backButton}
            icon={<BackIcon />}
            size="large"
            type="dashed"
            onClick={onButtonClick ? onButtonClick : () => navigate(-1)}
          />
        )}
        <div className={styles.titleContainer}>
          {title}
          {subTitle}
        </div>
      </div>
      <div>{rightContent}</div>
    </div>
  )
}

export default PageHeader
